import React, { useState, useContext, useEffect } from "react";
import { makeStyles, Typography, Button, TextField } from "@material-ui/core";
import Logo from "../assets/Main/logo.png";
import { AuthContext } from "../context/Authcontext";
import { useHistory } from "react-router-dom";

export default function Login() {
  const classes = useStyles();
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setSenha] = useState("");
  const { login, token } = useContext(AuthContext);
  function handleSubmit(e) {
    e.preventDefault();
    login({ email, password });
  }

  useEffect(() => {
    if (token) {
      history.push("/configuracoes");
    }
  }, [token, history]);

  return (
    <div className={classes.root}>
      <div className={classes.titulo}>
        <a href="/">
          <img src={Logo} alt="Logo" className={classes.logo} />
        </a>
        <div className={classes.separador} />
        <Typography className={classes.admin}>ADMIN</Typography>
      </div>
      <form
        noValidate
        autoComplete="off"
        className={classes.formulario}
        onSubmit={handleSubmit}
      >
        <TextField
          id="outlined-basic"
          label="E-mail"
          variant="outlined"
          className={classes.campo}
          onChange={({ target }) => setEmail(target.value)}
        />
        <TextField
          type="password"
          id="outlined-basic"
          label="Senha"
          variant="outlined"
          className={classes.campo}
          onChange={({ target }) => setSenha(target.value)}
        />
        <Button className={classes.entrar} type="submit">
          ENTRAR
        </Button>
      </form>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: "320px",
    width: "345px",
    flexDirection: "column",
    alignItems: "center",
    display: "flex",
    border: "1px solid gray",
    borderRadius: "5px",
  },
  titulo: {
    height: "90px",
    width: "100%",
    flexDirection: "row",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.colors.gray4,
  },
  separador: {
    backgroundColor: theme.colors.darkBlue,
    height: "65px",
    width: "3px",
  },
  admin: {
    color: theme.colors.darkBlue,
    font: "IBM Plex Sans",
    fontSize: "35px",
    marginLeft: "16px",
  },
  logo: {
    height: "90px",
    width: "136px",
  },
  entrar: {
    height: "46px",
    width: "120px",
    fontSize: "18px",
    color: theme.colors.white,
    backgroundColor: theme.colors.darkBlue,
    borderRadius: "5px",
  },
  formulario: {
    height: "230px",
    width: "343px",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: "20px",
    display: "flex",
    backgroundColor: theme.colors.white,
  },
  campo: {
    height: "50px",
    width: "313px",
  },
}));
